import {
  VinScannerUiResult,
  mapRTUUIResult,
  withSBErrorHandling,
  type ResultWrapper,
  type VinScannerScreenConfiguration,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotVinImpl = {
  async startScanner(configuration: VinScannerScreenConfiguration): Promise<ResultWrapper<VinScannerUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<VinScannerUiResult>(await ScanbotSDKPlugin.startVinScanner(configuration), VinScannerUiResult),
    );
  },
};
